import React from "react";
import "./style.css";

const AboutUsContent = () => {
  return (
    <section className="aboutus-content">
      <div className="aboutus-content__inner">

        <div className="aboutus-content__intro">
          <p className="aboutus-content__paragraph">
            <i>The oils babe</i> nu este doar un <strong>brand</strong>.
          </p>
          <p className="aboutus-content__paragraph">
            Este povestea unei femei care și-a găsit drumul înapoi către sine.
            Născut dintr-o experiență profund personală de vindecare emoțională și
            reconectare interioară, brandul aduce împreună reconectarea cu sinele,
            educația holistică și puterea naturii.
          </p>
        </div>
{/* 
        <div className="aboutus-content__divider">
          <span className="aboutus-content__divider-line" />
          <span className="aboutus-content__divider-dot" />
          <span className="aboutus-content__divider-line" />
        </div> */}

        <div className="aboutus-content__beliefs">
          <p className="aboutus-content__beliefs-label">Valorile mele</p>
          <ol className="aboutus-content__beliefs-list">
            <li className="aboutus-content__belief-item">
              <span className="aboutus-content__belief-num">01</span>
              <span className="aboutus-content__belief-text">Cred în frumusețea unui stil de viață <strong>conștient</strong>.</span>
            </li>
            <li className="aboutus-content__belief-item">
              <span className="aboutus-content__belief-num">02</span>
              <span className="aboutus-content__belief-text">În <strong>liniștea</strong> pe care o poate aduce un simplu moment pentru tine.</span>
            </li>
            <li className="aboutus-content__belief-item">
              <span className="aboutus-content__belief-num">03</span>
              <span className="aboutus-content__belief-text">În puterea aromelor de a <strong>transforma</strong> stări, spații și emoții.</span>
            </li>
          </ol>
        </div>
{/* 
        <div className="aboutus-content__divider">
          <span className="aboutus-content__divider-line" />
          <span className="aboutus-content__divider-dot" />
          <span className="aboutus-content__divider-line" />
        </div> */}

        <div className="aboutus-content__body">
          <p className="aboutus-content__paragraph">
            Prin fiecare recomandare, workshop și experiență creată, misiunea "the
            oils babe" este să inspire oamenii să încetinească, să respire și să
            își creeze propriile ritualuri de echilibru și stare de bine.
          </p>
        </div>

        <blockquote className="aboutus-content__closing">
          Mai mult decât uleiuri esențiale —<br />
          <em>o experiență de reconectare cu tine.</em>
        </blockquote>

      </div>
    </section>
  );
};

export default AboutUsContent;
